var GlobalModule,BaseModule;

BaseModule = {

    last_request_data : null,

    data : {
        page        : 1,
        limit       : 42,
        order_by    : 'id:desc'
    },

    actions:function(action,id){
		"use strict";
        var module = this,module_name = module.data.module;

        switch(action){
            case "new":
                GlobalModule.new_entry(module_name);
                break;
            case "edit": case "duplicate":

                if( $('.page-header').data('target') == module_name  ){
                    
                    GlobalModule.load_entry(id,module_name,action);
               }else{
                    window.location = '/' + module_name+'/'+id;
                }
                break;
            case "delete":
                GlobalModule.delete_entry(id,module_name);
                break;
            case "delete-selected":
                var ids = [];
                $('input[name="selection[]"]:checked').each(function(){
                    ids.push($(this).val());
                });
                if(ids.length>0){
                     GlobalModule.delete_entry(ids.join(','),module_name);
                }
               
                break;
            case "maintenance":
                GlobalModule.maintenance( module_name, id  );

                break;
            case "show_in_grid": case "remove_from_grid":case "spotlight": case "unspotlight":case "feature": case "unfeature": case "activate": case "inactivate":case "approve": case "reject":case "is_sale":case "unsale":case "make-new": case "make-old":
                GlobalModule.status_update( module_name, id , action );
                break;
           case "activate-selected": case "deactivate-selected":
                 var ids = [];
                $('input[name="selection[]"]:checked').each(function(){
                    ids.push($(this).val());
                });
                  if(ids.length>0){
                       GlobalModule.status_update_selected( module_name,  ids.join(',') , action );
                  }
               
                break;
        }
    },

	setFilter: function(f, v) {
		"use strict";
        if(f !== 'page'){
            this.data.page = 1;
        }
        this.data[f] = v;
        this.load_list();
        return false;
    },

    after_load_entry: function() {
        "use strict";
        this.save();
    },
    
    onImageError : function(){
        var src= $(this).attr('src').replace('s3.iknow','api.iknow');
        $(this).attr('src',src);
        $(this).off('error');
    },

    after_load_list:function(){
        var module_name = this.data.module,module=this;

        $('.list-container[data-target="'+module_name+'"]').on('item-selected',function($e,data, is_checked){

            var selection_container = $(this).closest(".modal-body").data('selectioncontainer');
            var cb = $(this).closest(".modal-body").data('cb');


            
            if(is_checked === true){

                if(selection_container !=null){ 
                    
                    var sm = $(this).closest(".modal-body").data('sm'),
                        selection_name = $(this).closest(".modal-body").data('selectionname'),
                        selection_markup = $(sm).html();

                    for(var i in data){

                        var counter = 0;
                        while(selection_markup.indexOf('data.'+i) != -1 && counter ++ < 5000 ){
                            selection_markup = selection_markup.replace('data.'+i,data[i]);
                        }
                    }

                    var $items = $(selection_markup);

                    $items.find('img').on('error',module.onImageError);

                    if($(selection_container).data('plg') == 'masonry'){
                        $(selection_container).append($items).masonry( 'appended', $items );
                    }else{
                        $(selection_container).append($items);
                    }
                    initForm(selection_container);

                    if(cb != null){
                        cb();
                    }
                }


            }else{
                if(selection_container !=null){
                    var selection_name = $(this).closest(".modal-body").data('selectionname');
                    $(selection_container).find('input:hidden[name="'+selection_name+'"][value="'+data.id+'"]').closest('.selection-item').remove();
                }
            }

        });


    },

    deep_linking : function(path){
        "use strict";
        var module = this,path_elements = path.split('/');
        if(path_elements.length === 1){
            module.load_list();
        }else if(path_elements.length === 2 && path_elements[1] === 'new'){
            module.actions('new');
        }else if(path_elements.length === 2 && path_elements[1] > 0){
            module.actions('edit',path_elements[1]);
        }
    },

    load_list : function(objectt){
        "use strict";

        var module = this,
            module_name = module.data.module,
            request_data = $.extend(false, module.last_request_data, {intent:'load-list'},objectt, module.data  ),
            filter_data = $('.filters[data-module="'+module_name+'"]').serializeArray();
            

        if(typeof(objectt) !=='undefined' && typeof(objectt.view) !=='undefined'){
            request_data.view = objectt.view;
        }      


        if(module_name == 'inventory') {
            request_data['manufacturer_id'] = [];
            request_data['category_id'] = [];
            request_data['distributor_id'] = [];
        }




        for(var i in filter_data){
            var name = filter_data[i].name, value = filter_data[i].value;
            if(module_name == 'inventory' && (name == 'distributor_id' || name == 'manufacturer_id' || name == 'category_id' ) ){
                if(typeof(request_data[name]) == 'undefined'){
                    request_data[name] = [];
                }
                if(request_data[name].indexOf(value ) == -1){
                    request_data[name].push(value);    
                }

            }else{
                request_data[name] = value;    
            }
            
        }

        var $list_container = $('.list-container[data-target="'+module_name+'"]');

        if(typeof(objectt) !=='undefined' && typeof(objectt.display_view) !=='undefined' && objectt.display_view =='popup'){
            $list_container = $('.modal  .list-container[data-target="'+module_name+'"]');

        }
        $('.page-header[data-target="'+module_name+'"]').show();
        $('.' + module_name + '-filters').show();
        $('.details-container[data-target="'+module_name+'"]').hide();

        $list_container.html('<span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span>');

        module.last_request_data = request_data;

        $list_container.off('item-selected');

        if(typeof(objectt) !=='undefined' && typeof(objectt.reset_request) !=='undefined'){
            request_data.show_in = null;          
        }

        $.ajax({
            url : API + module.api_route,
            data:request_data,
            error:function(){
                delete module.data['no-cache'];
                $('.list-container[data-target="'+module_name+'"]').html('<div class="alert alert-danger">Ooops...something went wrong</div>');
            },
            success:function(data){
                console.log(data);
                $('.'+module_name+'-filters').replaceWith(data.filters);
                $('.'+module_name+'-filters').show();
                var $items = $(data.markup);
                $items.find('img').on('error',module.onImageError);
                $list_container.html($items);
                                
                var checked = [];
                $('.related-'+module_name+'-list input[name="'+module_name+'[]"]').each(function(){
                    checked.push($(this).val());
                });

                $list_container.find('input.selectable-item:checkbox').each(function(){
                    var id = $(this).val();
                    $(this).attr('checked' , checked.indexOf(id) != -1);
                });

                $list_container.find('input.selectable-item:checkbox').on('change',function(){
                    var checked = $(this).is(":checked"), 
                        caller = $(this).closest('.list-container[data-target="'+module_name+'"]'),
                        all_data = $(this).data() ;
                        
                    setTimeout(function(){
                        caller.trigger('item-selected',[all_data, checked]);
                    },10);
                        
                });


                initForm('.list-container[data-target="'+module_name+'"]');
                initForm('.filters-form');
                module.after_load_list();

            }
        });
    },

    cropper:function($source , $width , $height , t, prv){

        var module_name = this.data.module, module = this, b = $('body');

        if($('.crop-modal').length === 0){
            var $markup = '<div class="modal fade modal-fade-in-scale-up show crop-modal" role="dialog" aria-labelledby="myModalLabel" style="z-index: 999999">\
                            <div class="modal-dialog modal-lg" role="document">\
                            <div class="modal-content">\
                                <div class="modal-header">\
                                    <h4 class="modal-title" id="myModalLabel">Cropper</h4>\
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\
                                </div>\
                                <div class="modal-body">\
                                    <div>\
                                    <img data-plg="cropper" data-target="input[data-name=\'file_id_crop\']" class="img-fluid" data-width="'+$width+'" data-height="'+$height+'" src="'+$source+'" />\
                                    </div>\
                                    <hr>\
                                        <button type="button" class="btn btn-default btn-sm apply-btn">Apply Crop Transformation</button>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>';
            b.append($markup);
        }



        $('.crop-modal').on('shown.bs.modal', function () {

            $('.crop-modal').find('[data-plg="cropper"]').each(function(){
                var target = $(t);
                var preview_container = $(prv);
                var cl = $(this), ratio = cl.data('width') / cl.data('height'),$modal = cl.closest('.modal') ;
                var p = target.val();
                if(p == '' || p ==null){
                    p = '[]';
                }
                cl.cropper({ aspectRatio: ratio, data : JSON.parse( p ) });

                $modal.find('.apply-btn').off('click');
                $modal.find('.apply-btn').on('click',function(){
                    var c = $modal.find('[data-plg="cropper"]');
                    var transformation = c.cropper('getData');

                    transformation.preview_width = c.cropper('getContainerData').width;
                    var preview = preview_container.data('src');

                    if(preview.indexOf('?v=')!=-1){
                        preview += '&transformation=' +  JSON.stringify(transformation);
                    }else{
                        preview += '?transformation=' +  JSON.stringify(transformation);
                    }

                    $(target).val(JSON.stringify(transformation));

                    preview_container.on('load',function(){
                        $(this).closest('.details').removeClass('loading');
                    }).attr('src', preview  ).closest('.details').addClass('loading');

                    $modal.modal('hide');
                });

            });



        }).on('hidden.bs.modal', function () {

            $(this).find('.apply-btn').off('click');
            $(this).find('[data-plg="cropper"]').cropper('destroy');

            $('.crop-modal').remove();

        }).modal('show');

    },

    load_list_dialog:function(sm, selection_name , selection_container , t , cb){
        var module_name = this.data.module,
            module = this,
            b = $('body');

        var title = t || module_name.toUpperCase();
        if($('#'+module_name+'-dialog-list').length === 0){

            b.append('<div id="'+module_name+'-dialog-list" class="modal fade modal-fade-in-scale-up show" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">\
                        <div class="modal-dialog modal-full" style="width: 96%;max-width: 100%;" >\
                            <div class="modal-content">\
                                <div class="modal-header">\
                                    <h4 class="modal-title " style="float:left">'+title+'</h4>\
                                    <button type="button"  style="float:right" class="close" data-dismiss="modal" aria-hidden="true">×</button>\
                                </div>\
                                <div class="modal-body"></div>\
                            </div>\
                        </div>\
                    </div>');
        }

        $("#"+module_name+"-dialog-list").on('shown.bs.modal', function () {

            $("#"+module_name+"-dialog-list .modal-body").data('sm',sm);
            $("#"+module_name+"-dialog-list .modal-body").data('selectionname',selection_name);
            $("#"+module_name+"-dialog-list .modal-body").data('selectioncontainer',selection_container);
            $("#"+module_name+"-dialog-list .modal-body").data('cb',cb);

            $("#"+module_name+"-dialog-list .modal-body").html('<div class="'+module_name+'-form"></div>' +
                '<div class="row" style="border-top: 1px solid #e1e6ed;">' +
                '<div class="col-lg-9 col-xl-10 " style="padding-top: 30px;">' +
                '<div class="'+module_name+'-list list-container container-fluid" data-target="'+module_name+'"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
                '</div>' +
                '<div class="col-lg-3 col-xl-2" style="border-left: 1px solid #e1e6ed;">' +
                '<div class="'+module_name+'-filters"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
                '</div>' +
                '</div>');

            module.load_list({display_view:'popup'});

        }).on('hidden.bs.modal', function () {

            $("#"+module_name+"-dialog-list .modal-body").data('sm',null);
            $("#"+module_name+"-dialog-list .modal-body").data('selectionname',null);
            $("#"+module_name+"-dialog-list .modal-body").data('selectioncontainer',null);
            $("#"+module_name+"-dialog-list .modal-body").data('cb',null);

            $("#"+module_name+"-dialog-list").remove();
            
        }).modal('show');
    },

    load_order_dialog:function(t){
        var module_name = this.data.module,
            module = this,
            b = $('body'); 
            module.data.page = 1;

        var title = t || module_name.toUpperCase();
        if($('#'+module_name+'-dialog-list').length === 0){

            b.append('<div id="'+module_name+'-dialog-list" class="modal fade modal-fade-in-scale-up show" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">\
                        <div class="modal-dialog modal-full" style="width: 96%;max-width: 100%;" >\
                            <div class="modal-content">\
                                <div class="modal-header">\
                                    <h4 class="modal-title " style="float:left">'+title+'</h4>\
                                    <button type="button"  style="float:right" class="close" data-dismiss="modal" aria-hidden="true">×</button>\
                                </div>\
                                <div class="modal-body"></div>\
                            </div>\
                        </div>\
                    </div>');
        }

        $("#"+module_name+"-dialog-list").on('shown.bs.modal', function () {

            $("#"+module_name+"-dialog-list .modal-body").html('<div class="'+module_name+'-form"></div>' +
                '<div class="row" style="border-top: 1px solid #e1e6ed;">' +
                '<div class="col-lg-12" style="border-left: 1px solid #e1e6ed;">' +
                '<div class="'+module_name+'-list list-container container-fluid" data-target="'+module_name+'"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
                '</div>' +
                '</div>');

 
            module.data.view          = 'order';            
            module.data.display_view  = 'popup';
            module.data['intent-action'] = 'update-order'; 

            module.load_list( { display_view : 'popup', 'view' : 'order', 'intent-action' :'update-order' } );


        }).on('hidden.bs.modal', function () {

            module.data.view          = 'grid';            
            module.data.display_view  = null;
            module.data['intent-action'] = null;             
            module.load_list({ 
                reset_request : true
            }); 


            
            /*
            intent: load-list
            module: pages
            page: 2
            limit: 42
            view: grid
            pagination: true
            */

            $("#"+module_name+"-dialog-list .modal-body").data('sm',null);
            $("#"+module_name+"-dialog-list .modal-body").data('selectionname',null);
            $("#"+module_name+"-dialog-list .modal-body").data('selectioncontainer',null);

            $("#"+module_name+"-dialog-list").remove();

        }).modal('show');
    }, 

    save:function(){

        var module_name = this.data.module,
            module = this,
            $form = $('.details-container[data-target="'+module_name+'"] form');




        $form.formValidation().on('err.form.fv',function(){
            GlobalModule.show_message('danger','Validation error occured. Looks like you are missing required fields');

        }).on('success.form.fv', function(e) {

            e.preventDefault();

            var $form = $(e.target),
                fv = $form.data('formValidation');

            if(module.before_save){
                module.before_save();
            }
  
            $form.find('button:submit').html('<i class="fa fa-spinner fa-spin"></i> Working On It').attr('disabled',true).addClass('disabled');

            $.ajax({
                url : API + $form.find('input[name="route"]').val(),
                data:$form.serialize(),
                type:'POST',
                error:function(){
                    $form.find('button[type="submit"]').removeAttr('disabled').removeClass('disabled');
                    GlobalModule.show_message('danger','Something went wrong');

                },
                success:function(data){

                    if(data.success){

                        window.history.pushState( {} , '', '/' + module_name );
                        $('body').removeClass('modal-open');
                        module.data['no-cache'] = 1;
                        module.load_list();
                        if(module.after_save_entry){
                            module.after_save_entry();
                        }
                    }else{
                        GlobalModule.show_message('danger',data.error);
                    }

                }
            });

        });
    }

};


GlobalModule = {
    alertTimeout:null,
    $body : null ,

    paginate:function(page,module_name){
        var m = module_name.split('-');
        window[ucwords(m)].data.page = page;
        window[ucwords(m)].load_list();
    },

    new_entry: function (module,action) {
        var m = module.split('-');
        $('.' + module + '-wrapper').hide();

        $.ajax({
            url : API + window[ucwords(m)].api_route,
            data: { intent      : 'new-entry', module      : module },
            success: function (data) {

                $('.page-header').hide();

                $('.' + module + '-filters').hide();
                $('.list-container[data-target="'+module+'"]').empty();
                $('.details-container[data-target="'+module+'"]').html(data.markup).show();

                initForm('.details-container[data-target="'+module+'"] form');

                if(window[ucwords(m)].after_load_entry){
                    window[ucwords(m)].after_load_entry();
                }
            }
        });

    },

    new_entry_modal: function (module_name,params) {
        var b = $('body');

        if($('#'+module_name+'-new-dialog-form').length === 0){

            b.append('<div id="'+module_name+'-new-dialog-form" class="modal fade" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">\
                        <div class="modal-dialog" >\
                            <div class="modal-content modal-lg">\
                                <div class="modal-header">\
                                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>\
                                    <h4 class="modal-title">'+module_name+'</h4>\
                                </div>\
                                <div class="modal-body ' + module_name + '-form "></div>\
                            </div>\
                        </div>\
                    </div>');
        }


        $('#'+module_name+'-new-dialog-form').data({'id':0,'module':module_name})
            .on('shown.bs.modal', function () {
                GlobalModule.new_entry(module_name);

            }).on('hidden.bs.modal', function () {
                $('#'+module_name+'-new-dialog-form .modal-body').empty();
            }).modal({
                backdrop:false,
                show:true
            });
        return false;
    },

    show_message:function(type,message,callback){

        switch (type) {
            case "success":
                break;
            case "warning":
                alert(message);
                break;
            case "error":
            case "danger":
                alert(message);
                break;
            case "info":
                alert(message);
                break;
            default:
                alert(message);
        }
    },

    load_entry: function (id,module,action,overwrites) {
        var m = module.split('-');

        $('.' + module + '-wrapper').hide();

        var url = API + window[ucwords(m)].api_route  +'/'+id;

        if(window[ucwords(m)].data.details_with){
            url += '/' + window[ucwords(m)].data.details_with;
        }else if(window[ucwords(m)].data.list_with){
            url += '/' + window[ucwords(m)].data.list_with;
        }else if(window[ucwords(m)].data.with){
            url += '/' + window[ucwords(m)].data.with;
        }

        if(action!='duplicate'){

            window.history.pushState( {} , '', '/' + module + '/'+id );
        }

        window[ucwords(m)].data['no-cache'] = 1;

        $.ajax({

            url : url,

            data: {
                id          : id,
                intent      : action,
                module      : module,
                overwrites  : overwrites
            },
            success: function (data) {

                delete window[ucwords(m)].data['no-cache'];

                $('.page-header').hide();

                $('.list-container[data-target="'+module+'"]').empty();
                $('.' + module + '-filters').hide();

                $('.details-container[data-target="'+module+'"]').html(data.markup).show();

                if(action === 'duplicate'){
                    $('.details-container[data-target="'+module+'"] form input.disabled_hidden_value').remove();
                     $('.details-container[data-target="'+module+'"] form input').removeAttr('disabled');
                     $('.details-container[data-target="'+module+'"] form input[name="id"]').val(0);
                     $('.details-container[data-target="'+module+'"] form input[name="common_id"]').val(0);
                }

                initForm('.details-container[data-target="'+module+'"] form');

                var $title = '';
                if( $('.details-container[data-target="'+module+'"] form input[name="label"]').length > 0){
                    $title = ' / ' +   $('.details-container[data-target="'+module+'"] form input[name="label"]').val();
                }else if( $('.details-container[data-target="'+module+'"] form input[name="title"]').length > 0){
                    $title = ' / ' +   $('.details-container[data-target="'+module+'"] form input[name="title"]').val();
                }else if( $('.details-container[data-target="'+module+'"] form input[name="name"]').length > 0){
                    $title = ' / ' +   $('.details-container[data-target="'+module+'"] form input[name="name"]').val();
                }else if( $('.details-container[data-target="'+module+'"] form input[name="attributes[name]"]').length > 0){
                    $title = ' / ' +  $('.details-container[data-target="'+module+'"] form input[name="attributes[name]"]').val();
                }

                $('h2.page-title small').html($title);

                if(window[ucwords(m)].after_load_entry){
                    window[ucwords(m)].after_load_entry();
                }
            }
        });
    },

    delete_entry:function(id,module_name){
		"use strict";
        $('#'+module_name+'-delete-dialog')
            .data({'id':id,'module':module_name})
            .modal({
                backdrop:false,
                show:true
            });
        return false;
    },

    delete_entry_confirmed:function(module,id){
		"use strict";
        var m = module.split('-');
        $.ajax({
            url : API + window[ucwords(m)].api_route+'/'+id,
            data:{ _method:'delete' },
            type:'POST',
            success:function(data){
            $('#'+module+'-delete-dialog').modal('hide');
            $('body').removeClass('modal-open');

            if(data.success){
                GlobalModule.show_message('success',data.success);
                window[ucwords(m)].data['no-cache'] = 1;
                window[ucwords(m)].load_list();
            }else{
                GlobalModule.show_message('danger',data.error);
            }
        }});
    },

    maintenance:function(module, id){
       "use strict";
        var m = module.split('-');

        $.ajax({
            url : API + window[ucwords(m)].api_route+'/maintenance/'+id,
            method:'POST',

            success:function(data){

                if(data.success){

                    window[ucwords(m)].data['no-cache'] = 1;
                    window[ucwords(m)].load_list();

                    GlobalModule.show_message('success',data.success);

                }else{
                    GlobalModule.show_message('danger',data.error);
                }
            }

        });
        return false;
    },

    status_update_selected:function(module, id,way , mmm){
       "use strict";
        var m = module.split('-');
        var muted = mmm || false;
        console.log(module);
        console.log(way);
        console.log(id);

        $.ajax({
            url : API + window[ucwords(m)].api_route+'/status',
            method:'POST',
            data:{ status:way, id:id },
            success:function(data){

                if(data.success){

                    window[ucwords(m)].data['no-cache'] = 1;
                    window[ucwords(m)].load_list();

                    GlobalModule.show_message('success',data.success);

                }else{
                    GlobalModule.show_message('danger',data.error);
                }
            }
        });
        return false;
    },

    status_update:function(module, id,way , mmm){
		"use strict";
        var m = module.split('-');
        var muted = mmm || false;


        $.ajax({
            url : API + window[ucwords(m)].api_route+'/'+id+'/status',
            data:{ status:way, _method:'put' },
            type:'POST',
            success:function(data){

                if(data.success){

                    if(muted) return false;

                    if(way == 'show_in_grid'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-show-in-grid').data('module');
                        $('div[data-id="'+id+'"]').find('.action-show-in-grid').removeClass('btn-default').addClass('btn-danger');
                        $('div[data-id="'+id+'"]').find('.action-show-in-grid').attr('onclick',mm + ".actions('unfeature',"+id+");return false;");

                    }else if(way == 'remove_from_grid'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-show-in-grid').data('module');

                        $('div[data-id="'+id+'"]').find('.action-show-in-grid').removeClass('btn-danger').addClass('btn-default');
                        $('div[data-id="'+id+'"]').find('.action-show-in-grid').attr('onclick',mm+ ".actions('feature',"+id+");return false;");

                    }else if(way == 'feature'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-feature').data('module');
                        $('div[data-id="'+id+'"]').find('.action-feature').removeClass('btn-default').addClass('btn-danger');
                        $('div[data-id="'+id+'"]').find('.action-feature').attr('onclick',mm + ".actions('unfeature',"+id+");return false;");

                    }else if(way == 'unfeature'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-feature').data('module');

                        $('div[data-id="'+id+'"]').find('.action-feature').removeClass('btn-danger').addClass('btn-default');
                        $('div[data-id="'+id+'"]').find('.action-feature').attr('onclick',mm+ ".actions('feature',"+id+");return false;");

                    }else if(way == 'spotlight'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-spotlight').data('module');
                        $('div[data-id="'+id+'"]').find('.action-spotlight').removeClass('btn-default').addClass('btn-danger');
                        $('div[data-id="'+id+'"]').find('.action-spotlight').attr('onclick',mm + ".actions('unspotlight',"+id+");return false;");

                    }else if(way == 'unspotlight'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-spotlight').data('module');

                        $('div[data-id="'+id+'"]').find('.action-spotlight').removeClass('btn-danger').addClass('btn-default');
                        $('div[data-id="'+id+'"]').find('.action-spotlight').attr('onclick',mm+ ".actions('spotlight',"+id+");return false;");

                    }else if(way == 'is_sale'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-is-sale').data('module');
                        $('div[data-id="'+id+'"]').find('.action-is-sale').removeClass('btn-default').addClass('btn-danger');
                        $('div[data-id="'+id+'"]').find('.action-is-sale').attr('onclick',mm + ".actions('unsale',"+id+");return false;");

                    }else if(way == 'unsale'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-is-sale').data('module');
                        $('div[data-id="'+id+'"]').find('.action-is-sale').removeClass('btn-danger').addClass('btn-default');
                        $('div[data-id="'+id+'"]').find('.action-is-sale').attr('onclick',mm+ ".actions('is-sale',"+id+");return false;");

                    }else if(way == 'make-new'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-new').data('module');

                        $('div[data-id="'+id+'"]').find('.action-new').removeClass('btn-default').addClass('btn-success');
                        $('div[data-id="'+id+'"]').find('.action-new').attr('onclick',mm+".actions('make-old',"+id+");return false;");

                    }else if(way == 'make-old'){
                        var mm =  $('div[data-id="'+id+'"]').find('.action-new').data('module');

                        $('div[data-id="'+id+'"]').find('.action-new').removeClass('btn-success').addClass('btn-default');
                        $('div[data-id="'+id+'"]').find('.action-new').attr('onclick',mm+".actions('make-new',"+id+");return false;");

                    }else{
                        window[ucwords(m)].data['no-cache'] = 1;
                        window[ucwords(m)].load_list();
                    }


                    GlobalModule.show_message('success',data.success);


                }else{
                    GlobalModule.show_message('danger',data.error);
                }
            }
        });
    },

    add_location : function (t) {
		"use strict";
        var template = t || '.item-select-template',
            html_template = $(template).html(),
            markup = $('<div style="clear:both;" class="item-row">'+html_template+'</div>');

        $('.locations-list').append(markup).fadeIn('slow');

        initForm('.locations-list .item-row:last');

        if($('.locations-list .item-row').length === 1){
            $('.remove-item-trigger').hide();
        }else{
            $('.remove-item-trigger').show();
        }
    },

    remove_location : function(t){
        "use strict";
        $(t).closest('.item-row').remove();
        if($('.item-list .item-row').length === 1){
            $('.remove-item-trigger').hide();
        }else{
            $('.remove-item-trigger').show();
        }
    },

    add_fullLocation : function (t) {
		"use strict";
        var template = t || '.item-select-template-full-location',
            html_template = $(template).html(),
            markup = $('<div style="clear:both;" class="item-row">'+html_template+'</div>');

        $('.full-locations-list').append(markup).fadeIn('slow');

        initForm('.full-locations-list .item-row:last');

        if($('.full-locations-list .item-row').length === 1){
            $('.remove-item-trigger').hide();
        }else{
            $('.remove-item-trigger').show();
        }
    },

    init:function()
    {
		"use strict";
        var module = this;

        initForm('body');

        $(document).on('click','.related-files-list .move-down',function(){
            var pos = $(this).closest('.selection-item').index();
            $(this).closest('.selection-item').detach().insertAfter( $('.related-files-list').find(  '.selection-item:eq('+pos+')' ) ).fadeIn('fast');
        });

        $(document).on('click','.related-files-list .move-up',function(){
            var pos = $(this).closest('.selection-item').index()-1;
            $(this).closest('.selection-item').detach().insertBefore( $('.related-files-list').find(  '.selection-item:eq('+pos+')' )).fadeIn('fast');
        });

        /* 
       $(document).on('click','.site-menu a',function(){
           var container = '.page';
            $(container).load($(this).attr('href')+' '+container+'  > * ',function(){

            });
            return false;
        });
        */

        $(document).on('click','.cropper-trigger',function(){
            News.cropper($(this).data('src'),$(this).data('width'),$(this).data('height') ,$(this).data('target'),$(this).data('prv'));
            return false;
        });

        $(document).on('click','.btn-new-entry-modal',function(){
            var module_name = $(this).data('module');
            module.new_entry_modal(module_name,$(this).data());
            return false;
        });
         $(document).on('click','.btn-export',function(){
            var module_name = $(this).data('module');
            var m = module_name.split('-');
            window[ucwords(m)].export($(this).data());
            return false;
        });
         
        $(document).on('click','.btn-import',function(){
            var module_name = $(this).data('module');
            var m = module_name.split('-');
            window[ucwords(m)].import_form($(this).data());
            return false;
        });
        $(document).on('click','.btn-new-entry',function(){
            var module_name = $(this).data('module');
            module.new_entry(module_name,$(this).data());
            return false;
        });
        $(document).on('click','.btn-reload-list',function(){
            var module_name = $(this).data('module');
            var m = module_name.split('-');
            window[ucwords(m)].load_list();
            return false;
        });
        $(document).on('click','.btn-cancel-edit',function(){
            var module_name = $(this).data('module');
            var m = module_name.split('-');
            if(typeof(window[ucwords(m)].original_data) !=='undefined'){

                for(var i in window[ucwords(m)].original_data){
                    window[ucwords(m)].data[i] = window[ucwords(m)].original_data[i];
                }


            }else{
               // window[ucwords(m)].data.view = 'grid';
                window[ucwords(m)].data.exclude = '';
                window[ucwords(m)].data.attributes = {};
            }

            window.history.pushState( {} , '', '/' + module_name );

            window[ucwords(m)].load_list();
            $('body').removeClass('modal-open');
            $('h2.page-title small').html('');

            return false;
        });

        $(document).on('click','.btn-update-order',function(){
            var module_name = $(this).data('module');
            var m = module_name.split('-');
            window[ucwords(m)].load_order_list();
            return false;
        });

        $(document).on('click','.btn-save-order',function(){
            var module_name = $(this).data('module');
            var m = module_name.split('-');
            window[ucwords(m)].save_order();
            $('body').removeClass('modal-open');

            return false;
        });

        $(document).on('click','.btn-cancel-save-order',function(){
            var module_name = $(this).data('module');
            var m = module_name.split('-');
            window[ucwords(m)].data.view = 'grid';
            window[ucwords(m)].data.exclude = '';
            window[ucwords(m)].load_list();
            $('body').removeClass('modal-open');

            return false;
        });

        $(document).on('click','.modal-footer .btn-delete',function(){
            var id = $(this).closest('.modal').data('id');
            var module_name = $(this).closest('.modal').data('module');
            module.delete_entry_confirmed(module_name,id);
            $('body').removeClass('modal-open');

            return false;
        });
        $(document).on('click','.modal-footer .btn-delete-filtered',function(){
            var module_name = $(this).closest('.modal').data('module');
            var m = module_name.split('-');
            window[ucwords(m)].delete_entry_confirmed($(this).closest('.modal').data());
            $('body').removeClass('modal-open');

            return false;
        });

        $(document).on('click','.modal-footer .btn-dismiss',function(){
            $(this).closest('.modal').modal('hide');
            $('body').removeClass('modal-open');

            return false;
        });


        $(document).on('click','.filters:visible .btn-search-trigger',function(){
            var module_name = $(this).closest('.filters').data('module');
            var m = module_name.split('-');
            window[ucwords(m)].data.page = 0;
            window[ucwords(m)].load_list();
            return false;
        });

        $(document).on('click','.filters:visible .btn-load-block-trigger',function(){
            var module_name = $(this).closest('.filters').data('module');
            var partial = $(this).closest('.filters').data('partial');
            var target = $(this).closest('.filters').data('target');
            var m = module_name.split('-');

            var data = {
                'module':module_name,
                'action':'get-partial-block',
                'partial':partial,
                'from':$(this).closest('.filters').find('input[name="from"]').val(),
                'to':$(this).closest('.filters').find('input[name="to"]').val(),
                'sales_status':$(this).closest('.filters').find('select[name="sales_status"] option:selected').val(),
                'owner':$(this).closest('.filters').find('select[name="owner"] option:selected').val()
            };



            $.ajax({
                data:data,
                success: function (data) {
                    if(data.markup){
                        $(target).html(data.markup);
                    }else{
                        GlobalModule.show_message('danger',data.error);
                    }
                }
            });

            return false;
        });
        $(document).on('click','.select-library-trigger',function () {

            Files.data.active_uploader = $(this).data('target');
            Files.data.select_from_library = 1;
            Files.data.view = 'grid';
            Files.load_list_dialog();
            return false;
        });

        $(document).on('keypress',".filters:visible .input-search input",function(event){
            if (event.which == 13) {
                var module_name = $(this).closest('.filters').data('module');
                var m = module_name.split('-');
                window[ucwords(m)].data.page = 0;
                window[ucwords(m)].load_list();
                event.preventDefault();
            } 
        });

        $(document).on('click', '.pagination  a', function () {
            if($(this).parent().hasClass('active')) return false;
            var page = $(this).data('page'),
                module_name = $(this).closest('.list-container').data('target');

            module.paginate(page,module_name);
            return false;
        });

        $(document).on('change','.selectable-all',function(){

            var checked = $(this).prop('checked');
            if(checked){
                $('.site-action').addClass('active');
            }else{
                $('.site-action').removeClass('active');
            }

            $(this).closest('table').find('input:checkbox[name="selection[]"]').prop('checked',checked);
        });


         $(document).on('change','select[name="actions-selected"]',function(){

             var action = $(this).val();
              if(action!==''){
                   var module_name =  $(this).data('module');
                    var m = module_name.split('-');
                    window[ucwords(m)].actions(action);
              }
            
        });


        
         $(document).on('click','.check-all',function(){
           if($(this).hasClass('checked')){
               $(this).removeClass('checked')
               $(this).closest('table').find('input:checkbox[name="selection[]"]').prop('checked',false);
           }else{
              $(this).addClass('checked')
             $(this).closest('table').find('input:checkbox[name="selection[]"]').prop('checked',true);
           }
            
        });

        $(document).on('submit','.filters-form',function(){
            var m = $(this).data('module').split('-');
            window[ucwords(m)].data.page = 0;
            window[ucwords(m)].load_list();

            $.slidePanel.hide();

            return false;
        });

        module.$body = $('body');
    } 
}

function initForm(target){    


    $(target).find('input,select,textarea').change(function(){
        if($(target).find('data-fv-field').length > 0){
            $(target).formValidation();    
        }
        
    });
    $(target).find('input,textarea').keyup(function(){
        if($(target).find('data-fv-field').length > 0){
            $(target).formValidation();    
        }
    });


    if(target == 'body' && $(target + ' [data-plg="slidePanel"]').length > 0){

        $(document).on('click',target + ' [data-plg="slidePanel"]',function(){

            var partial = $(this).attr('href');
            var m = $(this).data('module').split('-');

            $.slidePanel.show({
                url: partial + '?' + $.param(window[ucwords(m)].last_request_data),
                settings: {
                    method: 'GET',
                    dataType:'html'
                }
            }, {
                skin:'site-sidebar',
                classes: {
                    base: 'slidePanel',
                    show: 'slidePanel-show',
                    loading: 'slidePanel-loading',
                    content: 'slidePanel-content',
                    dragging: 'slidePanel-dragging',
                    willClose: 'slidePanel-will-close'
                },
                mouseDragHandler: null,
                mouseDrag: false,
                touchDrag: false,
                pointerDrag: false,
                closeSelector: '.slidePanel-close',
                useCssTransforms3d: false,
                useCssTransforms: false,
                loading: {
                    template: function(options) {
                        return '<div class="' + options.classes.loading + '"><div class="spinner"></div></div>';
                    }
                },
                afterShow:function(){

                },
                afterLoad:function(){
                    initForm('.slidePanel-show .slidePanel-inner-section');
                }
            });

            return false;
        });
    }

    if($(target + ' [data-plg="partial"]').length > 0){

        $(target + ' [data-plg="partial"]').each(function(){

            var c = $(this).data('partial');
            var uniqid = 'partial-' + Math.floor(Math.random()* 1000000);
            $(this).attr('id',uniqid);
            $(this).load(c,function(){
                initForm('#' + uniqid);
            })

        });

    }

    if($(target + ' [data-plg="ajax-data"]').length > 0){

        $(target + ' [data-plg="ajax-data"]').each(function(){
            var caller = $(this),req = caller.data('attrs');

            $.ajax({
                url : API + req.route,

                data:req,
                type:'GET',
                success:function(data){
                    for(var i in data){
                        caller.find('.data-' + i).text(data[i]);
                    }
                }
            });
        });
    }

    if($(target + ' [data-plg="uploader"]:visible').length > 0){
        $(target + ' [data-plg="uploader"]:visible').each(function(){
            var c = $(this);

            if(c.data('single')){
                Files.singleUploader(c.attr('id'));
            }else if(c.data('multiple')){
                Files.multipleUploader(c.attr('id'));
            }
            c.data('plg','uploader-initiated');
        });
    }

    $(target + ' input[data-plg="datepicker"]').datepicker({
        'format':'yyyy-mm-dd',      
    }).on('changeDate', function() {
        $(target + ' input[data-plg="datepicker"]').trigger('change');
    });

    $(target + ' input[data-plg="timepicker"]').each(function(){
        var $this = $(this);
        $this.timepicker($this.data());
    });

    if($(target + ' [data-plg="masonry"]').length > 0){
        var $grid = $(target + ' [data-plg="masonry"]').masonry({});
        $grid.imagesLoaded(function() {
            $grid.masonry('layout');
        });
    }

    if($(target).data('plg') == 'masonry'){
        $(target).masonry();
    }

    if($(target + ' [data-plg="tabs"]').length > 0){

        $(target + ' [data-plg="tabs"]').each(function(){
            var c = $(this);

            c.find('a').on('click',function(){
                
                var t = $(this).attr('href');
                
                $('.tab-pane.active').removeClass('active');
                $(t).addClass('active');

                $('.nav-item a.active').removeClass('active');
                
                $(this).addClass('active');
                
                setTimeout(function(){
                    initForm(t);
                },200);

            });
        });
    }

    if($(target + ' select[data-plg="select2"]:visible').length > 0){
        $(target + ' select[data-plg="select2"]:visible').each(function(){
            var $this = $(this),
            data = $this.data(),
            options = {
                width: 'resolve',
                placeholder: "Select a value",
                allowClear:true
            };

            if(data.ajax){

                options.ajax = {
                    url : API +  data.ajax,
                    dataType: 'json',
                    delay: 50,

                    data: function (params) {
                        var search_for = typeof(params.term)!=='undefined'?params.term:'';

                        if($this.attr('name') == 'vehicle[make][]'){
                            data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="vehicle[year][]"]').val();
                        }else if($this.attr('name') == 'MakeID'){
                            data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="YearID"]').val();
                        }

                        else if($this.attr('name') == 'vehicle[model][]'){
                            data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="vehicle[year][]"]').val();
                            data.requestData['additionals']['make'] = $this.closest('.vehicle-search').find('select[name="vehicle[make][]"]').val();
                        }else if($this.attr('name') == 'ModelID'){
                            data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="YearID"]').val();
                            data.requestData['additionals']['make'] = $this.closest('.vehicle-search').find('select[name="MakeID"]').val();
                        }

                        else if($this.attr('name') == 'vehicle[trim][]'){
                            data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="vehicle[year][]"]').val();
                            data.requestData['additionals']['make'] = $this.closest('.vehicle-search').find('select[name="vehicle[make][]"]').val();
                            data.requestData['additionals']['model'] = $this.closest('.vehicle-search').find('select[name="vehicle[model][]"]').val();

                        }else if($this.attr('name') == 'SubModelID'){
                            data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="YearID"]').val();
                            data.requestData['additionals']['make'] = $this.closest('.vehicle-search').find('select[name="MakeID"]').val();
                            data.requestData['additionals']['model'] = $this.closest('.vehicle-search').find('select[name="ModelID"]').val();

                        }else if(data.requestData){
                            if($this.closest('.vehicle-search').find('select[name="YearID"]').length > 0){
                                data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="YearID"]').val();
                                data.requestData['additionals']['make'] = $this.closest('.vehicle-search').find('select[name="MakeID"]').val();
                                data.requestData['additionals']['model'] = $this.closest('.vehicle-search').find('select[name="ModelID"]').val();
                                data.requestData['additionals']['trim'] = $this.closest('.vehicle-search').find('select[name="SubModelID"]').val();
                            }else if($this.closest('.vehicle-search').find('select[name="vehicle[year][]"]').length > 0){
                                data.requestData['additionals']['year'] = $this.closest('.vehicle-search').find('select[name="vehicle[year][]"]').val();
                                data.requestData['additionals']['make'] = $this.closest('.vehicle-search').find('select[name="vehicle[make][]"]').val();
                                data.requestData['additionals']['model'] = $this.closest('.vehicle-search').find('select[name="vehicle[model][]"]').val();
                                data.requestData['additionals']['trim'] = $this.closest('.vehicle-search').find('select[name="vehicle[trim][]"]').val();


                            }
                        }
                        console.log(data);

                        return $.extend(false, {
                            q: typeof(data.search)!='undefined' && typeof(search_for)!='undefined' ? data.search+'=@'+search_for : search_for,
                            page: params.page
                        } ,data.requestData);
                    },
                    processResults: function (res, params) {
                        params.page = params.page || 1;
                        var value_field = data.value || 'id';

                        var label_field = data.label || data.search;

                        return {
                            results:  $.map(res.data, function (item) {
                                return {
                                    all_data: item,
                                    text: item[label_field],
                                    id: item[value_field]
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    },
                    cache: true
                };
                options.minimumInputLength = 0;

                if($this.data('selected_value')){
                    $.ajax({
                        url : API +  data.ajax,
                        dataType: 'json',
                        data: {
                            id:$this.data('selected_value')
                        },
                        error:function(){},
                        success:function(res){
                            var label_field = data.label || data.search;
                            var value_field = data.value || 'id';

                            $this.html('<option value="'+res.data[0][ value_field ]+'">'+res.data[0][label_field]+'</option>');
                            $this.select2(options);
                        }
                    });
                }
            }

            $this.select2(options);


    });
    }


    if($(target + ' .wysiwyg-inline').length > 0){

        $(target + ' .wysiwyg-inline').each(function(){
            var id = 'partial-' + Math.floor(Math.random()* 1000000);
            $(this).attr('id',id);
            CKEDITOR.inline(id , {});
        })
    }

    if($(target + " textarea.editor:visible").length > 0){

        $(target + " textarea.editor").closest('form').on('submit',function(){
            for (instance in CKEDITOR.instances)
                CKEDITOR.instances[instance].updateElement();
        });

        $(target + " textarea.editor:visible").each(function(){

            CKEDITOR.replace( $(this).attr('id') , {
                allowedContent : true,
                on:{
                      instanceReady : function ( evt ){
                         var editor = evt.editor,
                            body = editor.document.getBody();
                         body.setAttribute( 'class', 'skin-guide' );
                      }
                   }
            } );
        });
    }
    if($(target + " textarea.code-editor:visible").length > 0){
        $(target + " textarea.code-editor.css:visible").each(function(){
            CodeMirror.fromTextArea($(this)[0], {
                lineNumbers: true,
                mode:  "css",
                viewportMargin:Infinity,
                foldGutter: true,
                gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"]

            });
        });

        $(target + " textarea.code-editor.js:visible").each(function(){
            CodeMirror.fromTextArea($(this)[0], {
                lineNumbers: true,
                viewportMargin:Infinity,
                foldGutter: true,
                gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"]

            });
        });

    }


}

function _isChar(e) {
    if (typeof e.which == "undefined") {
        return true;
    } else if (typeof e.which == "number" && e.which > 0) {
        return !e.ctrlKey && !e.metaKey && !e.altKey && e.which != 8 && e.which != 9;
    }
    return false;
}
function ucwords (str) {
    if(typeof(str) == 'array' || typeof(str) == 'object'){
        var s = '';
        for(var i in str){
            s += (str[i] + '').replace(/^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function ($1) {
                return $1.toUpperCase();
            });
        }
        return s;
    }else{
        return (str + '').replace(/^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function ($1) {
            return $1.toUpperCase();
        });
    }
}
function getToday(){
    return format_date(new Date());
}
function getMonday( ) {
    var date = new Date();
    var day = date.getDay() || 7;
    if( day !== 1 )
        date.setHours(-24 * (day - 1));
    return format_date(date);
}

function lastDayPreviousMonth() {
    var d = new Date();
    d.setDate(0); // set to last day of previous month
    return format_date(d);
}
function firstDayPreviousMonth() {
    var d = new Date();
    d.setDate(0);
    d.setDate(1); // set to the first day of that month
    return format_date(d);
}
function format_date(d){
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1; //Months are zero based
    var curr_year = d.getFullYear();
    return(curr_month + "/" + curr_date + "/" + curr_year);
}
function unique_ids($content){
    var uniq = Math.floor(Math.random()* 1000000),counter = 0;
    while($content.indexOf( '--unique--' )!= -1 && counter ++ < 5000){
        $content = $content.replace('--unique--' , 'partial-' + uniq );
    }
    return $content;
}

var Builder = {

    target : null,
    active_component : null,

    set_target : function(t){
        this.target = t;
        return this;
    },

    component_specific : function(comp){
        var $this = this,
            container = $this.target,
            all_components = container.find('.article-component');

        //
        comp.find('[data-target="#componentsModal"]').on( 'click',function($e){
            $this.active_component = $(this).closest('.article-component');
        });
        comp.find('.add-placeholder').on( 'click',function($e){
            var template = $(this).data('template');
            var target = $(this).data('target');
            var $content = $(template).html();
            var uniq = Math.floor(Math.random()* 1000000);
            var counter = 0;
            while($content.indexOf( '--unique--' )!= -1 && counter ++ < 5000){
                $content = $content.replace('--unique--' , 'partial-' + uniq );
            }
            $(target).append($content);
            initForm( target + ' .selection-item:last'  ) ;
            return false;

        });
        comp.find('.move-down').on('click',function(){
            var pos = comp.index();
            comp.detach().insertAfter( container.find(  '.article-component:eq('+pos+')' ) );
            $this.update_order();
        });
        comp.find('.move-up').on('click',function(){
            var pos = comp.index()-1;
            comp.detach().insertBefore( container.find(  '.article-component:eq('+pos+')' ) );
            $this.update_order();
        });


    },


    update_order:function(){

        var all_components = this.target.find('.article-component');

        all_components.each(function(index){

            var d = $(this).data('component');
            d.sort_position = index;
            $(this).data('component',d);

            if( all_components.length == 1){
                $(this).find('.move-up').hide();
                $(this).find('.move-down').hide();
            }else if(index == 0){
                $(this).find('.move-up').hide();
                $(this).find('.move-down').show();
            }else if(index == all_components.length - 1){
                $(this).find('.move-up').show();
                $(this).find('.move-down').hide();
            }else{
                $(this).find('.move-up').show();
                $(this).find('.move-down').show();
            }
        });

    },

    setup : function(){

        var $this = this,
            container = $this.target,
            all_components = container.find('.article-component');

        all_components.each(function(){

            var comp = $(this);

            $this.component_specific(comp);
        });

        if(container.find('.article-component:last').length> 0){
            $this.active_component =  container.find('.article-component:last');

        }

        $('.select-template').on('click',function($e){

            var names = $(this).data('name').split('+');

            for( var i in names ){
                var n = names[i];
                var $content = $('.component-select-template[data-name="'+n+'"]').html();
                var uniq = Math.floor(Math.random()* 1000000);
                var counter = 0;
                while($content.indexOf( '--unique--' )!= -1 && counter ++ < 5000){
                    $content = $content.replace('--unique--' , 'partial-' + uniq );
                }
                var markup = $($content).attr('id', 'component-partial-'+uniq);

                if(container.find('.article-component:last').length > 0){
                    markup.insertAfter(container.find('.article-component:last'));
                }else{
                    $('.template-builder-list').append(markup);
                }


                initForm('#component-partial-'+uniq);

                $('#component-partial-'+uniq).data('component',{
                    id:0, name:n,data:{}
                });

                $this.component_specific($('#component-partial-'+uniq ));

                setTimeout(function(){
                    // START WITH 3 DUMMY IMAGES
                    $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');
                    $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');
                    $('#component-partial-'+uniq).find('.add-placeholder').trigger('click');

                },10);


                $(this).closest('.modal').modal('hide');

            }
            $this.update_order();
            $e.preventDefault();
        });

        for(var i in form_components){
            this.target.find('.article-component:eq('+i+')').data('component',form_components[i]);
        }
        this.update_order();

    },

    commit : function(){

        var all_component_data = [], $form = this.target;

        this.target.find('.article-component').each(function(index){
            var component = $(this);

            var component_data =  $(this).data('component');

            component.find('.content-editable').each(function(){

                var name = $(this).data('name').split('.'),
                    component_data = $(this).closest('.article-component').data('component');

                component_data.data[ String(name[0]) ] = $(this).html();
                if(component_data.data[ String(name[0]) ] == ''){
                    component_data.data[ String(name[0]) ] = $(this).val();
                }

                $(this).closest('.article-component').data('component' , component_data);
            });


            if(component.data('component')){

                component_data =  $(this).data('component');

                component_data.sort_position = index + 1;

                if(component.data('key')){

                    //component_data['data'] = {};
                    component_data['data']['images'] = [];
                    component_data['data']['images_crops'] = [];
                    component_data['data']['images_uploads'] = [];
                    component_data['data']['images_captions'] = [];

                    component.find('input[data-name="' + component.data('key')+'"]').each(function(){
                        var vv = $(this).val();
                        component_data['data']['images'].push(vv);
                    });
                    component.find('input[data-name="' + component.data('key')+'_crop"]').each(function(){
                        var vv = $(this).val();
                        component_data['data']['images_crops'].push(vv);
                    });
                    component.find('input[data-name="' + component.data('key')+'_uploader_filename"]').each(function(){
                        var vv = $(this).val();
                        component_data['data']['images_uploads'].push(vv);
                    });
                    component.find('[data-name="' + component.data('key')+'_caption"]').each(function(){
                        var vv = $(this).html();
                        component_data['data']['images_captions'].push(vv);
                    });
                }
                all_component_data.push(component_data);
            }

        });

        $form.find('input[name="components"]').val(JSON.stringify(all_component_data));
    }
}
function scroll2element(el){
   $('html, body').animate({
        scrollTop: $(el).offset().top
    }, 1000);
}

$(document).ready(function(){
    GlobalModule.init();
});
